import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { AskTheAuthorComponents, AskTheAuthorStores } from "../react_isomorphic/mobile/ask_the_author";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";
import { merge } from "lodash";

window.ReactComponents = merge({}, GlobalComponents, AskTheAuthorComponents, HeaderComponents);
window.ReactStores = merge({}, GlobalStores, AskTheAuthorStores, HeaderStores);
